import store from "./store";
const memberStore = {
    state: {
        // 로그인 여부
        status: '',
        loginDt: '',
        // 네이버 회원가입
        naverYn: 'N',
        naverEmail: '',
        naverName: '',
        // 본인인증
        niceType: '',
    },
    mutations: {
        // 로그인 여부
        setStatus: function (state, status) {
            state.status = status;
        },
        setLoginDt: function (state, loginDt) {
            state.loginDt = loginDt;
        },
        setNaverYn: function (state, naverYn) {
            state.naverYn = naverYn;
        },
        setNaverEmail: function (state, naverEmail) {
            state.naverEmail = naverEmail;
        },
        setNaverName: function (state, naverName) {
            state.naverName = naverName;
        },
        // 본인인증 타입
        setNiceType: function (state, niceType) {
            state.niceType = niceType;
        },
        // 초기화
        init: function(state){
            for(let i in state) {
                if(i != 'status' && i != 'loginDt') state[i] = ''
            }
        }
    },
    getters: {
        getStatus: state => {
            return state.status
        },
        getLoginDt: state => {
            return state.loginDt
        },
        getNaverYn: state => {
            return state.naverYn
        },
        getNaverEmail: state => {
            return state.naverEmail
        },
        getNaverName: state => {
            return state.naverName
        },
        getNiceType: state => {
            return state.niceType
        },
    },
    actions: {
        setLoginStatus({commit}, status){
            if(store.state.memberStore.status){
                commit('setStatus', status);
                setTimeout(() => {
                    commit('setStatus', false);
                }, 600000);
            }
        }
    }
}

export default memberStore